
export interface ShopAvailabilityRequest {
  shop_id: string;
  method: number;
  day: string;
}
